import React from "react";

// constants
import { contact } from "../../../constants/pages";
import AnimatedPage from "../../../components/animation/AnimatedPage";
import TextInput from "../../../components/elements/form/TextInput";
import TextBox from "../../../components/elements/form/TextBox";
import Button from "../../../components/elements/form/Button";

const ContactUs = () => {
  return (
    <AnimatedPage>
      <div className="w-full bg-customgreen py-12 px-6 xl:px-0 pt-32">
        <section className="max-w-7xl mx-auto w-full overflow-hidden rounded-2xl shadow-xl bg-white">
          <div className="grid md:grid-cols-2">
            {/* Contact Information */}
            <div className="bg-primary-700 rounded-xl p-12 m-6">
              <h3 className="font-bold text-3xl text-white">Contact Us</h3>
              <div>
                {contact.ikonss.map((ikons, index) => (
                  <div key={index.toString()}>
                    <div className="flex mt-6">
                      <img
                        className="h-6"
                        src={ikons.icons}
                        alt="Hero Section"
                      />
                      <div className="ml-3">
                        <h5 className="text-xl font-semibold tracking-tight text-white dark:text-white">
                          {ikons.title}
                        </h5>
                        <p className="font-normal text-white mt-3">
                          {ikons.content}
                        </p>
                        <p className="text-white">{ikons.content1}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact form */}
            <div className="w-full bg-white p-8 sm:p-12 lg:p-16">
              <form>
                <div className=" space-y-6">
                  <TextInput
                    label="Full Name"
                    type="text"
                    name="fullname"
                    value=""
                    placeholder="John Doe"
                    required
                    onChange={() => null}
                  />

                  <TextInput
                    label="Email"
                    type="email"
                    name="email"
                    value=""
                    placeholder="johndoe@email.com"
                    required
                    onChange={() => null}
                  />

                  <TextInput
                    label="Phone Number"
                    type="text"
                    name="phone"
                    value=""
                    placeholder="+234"
                    required
                    onChange={() => null}
                  />

                  <TextBox
                    label="Message"
                    name="message"
                    value=""
                    placeholder="Write your message here"
                    onChange={() => null}
                    required
                    status=""
                    rowsValue={6}
                  />
                  <Button
                    type="submit"
                    title="Submit"
                    onHandler={() => null}
                    className="text-white bg-primary-700 hover:bg-bggreen focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-xl text-lg w-full sm:w-auto px-10 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  />
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </AnimatedPage>
  );
};

export default ContactUs;
